import React from "react";
import { useTheme } from "../../context/themeContext";
import { TOKENS, BRAND } from "./dashboardShared";
import TherapistAnalytics from "./TherapistAnalytics";
import TestAnalytics from "./TestAnalytics";
import OverallAnalytics from "./OverallAnalytics";
import { useAuth } from "../../context/authContext";


// ---------------------------------------------------------------------------
// Combined page — same look and behavior as the original single-file
// TestAnalyticsPage, just composed from the two standalone components so
// each can also be used on its own elsewhere. Each child fetches its own
// data independently (same as the original, which had two separate
// useEffects), so no props need to be passed here.
// ---------------------------------------------------------------------------

export default function AnalyticsDashboard() {
  const { isDark } = useTheme();
  const t = TOKENS[isDark ? "dark" : "light"];
  const {code} = useAuth();

  return (
    <div className={"min-h-screen w-full " + t.pageWash}>
      <div className={"w-full px-4 py-8 sm:px-8 lg:px-12 " + t.textPrimary}>
        <div className="mx-auto max-w-6xl">
          {code && code =="AIIMS"? <OverallAnalytics wrapInPageShell={false}  /> : <TherapistAnalytics wrapInPageShell={false} />}
          <TestAnalytics wrapInPageShell={false} showFooter={false} showBg={true} />
          

          <div
            className={`mt-2 flex flex-wrap items-center justify-center gap-1 px-4 pb-8 text-center text-xs ${t.textFaint}`}
          >
            <span>Made with</span>
            <span style={{ color: BRAND.pink }}>💗</span>
            <span>
              by Infiheal — private, judgment-free insights for a healthier
              organization.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}